import Table, { TableProps } from '@ui-components-3/ui/lib/components/Table'
import { TableModel } from '@ui-components-3/ui/lib/components/Table/types'
import { TableEmptyState, TableFooter } from '../common'
import flexRender from '@ui-components-3/ui/lib/components/Table/utils/flexRender'
import { FC } from 'react'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

type CommonTableProps = TableProps & {
  model: TableModel
  onRowClick?: (r: any) => void
  'aria-label': string
  renderEmptyState?: FC
  hideFooter?: boolean
}

const CommonTable = ({ model, onRowClick, renderEmptyState, hideFooter, ...props }: CommonTableProps) => {
  return (
    <Table
      colorVariant="primary"
      variant="striped"
      footer={hideFooter ? null : <TableFooter />}
      {...props}
      model={model}
    >
      <Table.Header>
        {model.getFlatHeaders().map(({ getContext, column, id }) => {
          const { meta, header, enableSorting } = column?.columnDef || {}

          return column.getIsVisible() ? (
            <Table.Column
              key={`header:${id}`}
              id={id}
              className={classNames('whitespace-nowrap', (meta as any)?.columnClassName)}
            >
              <div className="gap-xs flex items-center">
                {flexRender(header, getContext())}
                {!!enableSorting && <Table.ColumnSorter id={id} />}
              </div>
            </Table.Column>
          ) : null
        })}
      </Table.Header>
      <Table.Body renderEmptyState={renderEmptyState || TableEmptyState}>
        {model.isLoading ? (
          <Table.DummyRows />
        ) : (
          model.getRowModel().rows.map((d) => (
            <Table.Row id={d.id} key={`row:${d.id}`} onAction={onRowClick ? () => onRowClick?.(d) : undefined}>
              {d.getVisibleCells().map(({ id, column, getContext }) => {
                const { cell, meta } = column?.columnDef || {}
                return (
                  <Table.Cell id={`cell:${id}`} key={`cell:${id}`} className={(meta as any)?.cellClassName}>
                    {flexRender(cell, { ...getContext() })}
                  </Table.Cell>
                )
              })}
            </Table.Row>
          ))
        )}
      </Table.Body>
    </Table>
  )
}

export default CommonTable
